import axios from "axios";

const API = "http://129.153.124.232:3000/api/messages";

function authConfig(token) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const getMessages = (token, channelId) =>
  axios.get(API, {
    ...authConfig(token),
    params: { channel_id: channelId },
  });

export const postMessage = (token, values) =>
  axios.post(`${API}/send`, values, authConfig(token));

export const deleteMessage = (token, messageId) =>
  axios.delete(`${API}/${encodeURIComponent(messageId)}`, authConfig(token));

export const getThreadMessages = (token, messageId) =>
  axios.get(`${API}/thread/${encodeURIComponent(messageId)}`, authConfig(token));